import SoftooMap from "../Map";
import Map from "ol/Map";
import { Point, MultiPoint, LineString,
         Polygon, MultiLineString, MultiPolygon } from "ol/geom";
import LinearRing from "ol/geom/LinearRing";
import GeometryCollection from "ol/geom/GeometryCollection";

import { Drawer } from "./Drawer";
import Feature from "ol/Feature";
import * as jsts from "jsts";
import { Extent, ICutFeature } from "../types";

interface ISplitGeom {
  splits: jsts.geom.Geometry[];
  splits2: jsts.geom.Geometry[];
}

function ExtentsAreIntersected(extent1:Extent, extent2:Extent) : boolean {
  return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] &&
         extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}

export class CutHole extends Drawer {
  private $map: SoftooMap;
  private target: Feature; // the feature to be cut
  private jstsOL3Parser;

  constructor(options) {
    let afterCut;
    if (options.source) {
      delete options.source; // we don't need to keep the drawing
    }
    if (options.afterCut) {
      afterCut = options.afterCut;
      delete options.afterCut;
    }
    super(options);

    if (afterCut) {
      this.afterCut = afterCut;
    }
    
    this.jstsOL3Parser = new jsts.io.OL3Parser();
    this.jstsOL3Parser.inject(Point, LineString, LinearRing, Polygon, MultiPoint, MultiLineString, MultiPolygon, GeometryCollection);
  }

  startCut(hole:Feature) {
    let holeGeom = <Polygon>hole.getGeometry();
    let jstsHoleGeom = this.jstsOL3Parser.read(holeGeom);
    let targetGeom = this.target.getGeometry();
    let jstsTargetGeom, cut = false;
    let original = this.cloneFeature(this.target);

    if (targetGeom instanceof MultiPolygon) {
      let i, polygons = targetGeom.getPolygons();
      for (i=0; i<polygons.length; i++) {
        jstsTargetGeom = this.jstsOL3Parser.read(polygons[i]);
        if (jstsHoleGeom.within(jstsTargetGeom)) {
          this.$map.addUndo(this.target, 'Update');
          //this.target.getGeometry().getPolygon(i).appendLinearRing(holeGeom.getLinearRing(0));
          polygons[i].appendLinearRing(holeGeom.getLinearRing(0));
          let p0 = this.jstsOL3Parser.read(polygons[0]);
          let mp = <MultiPolygon>this.jstsOL3Parser.write(p0);
          for (let j=1; j<polygons.length; j++) {
            mp.appendPolygon(polygons[j]);
          }
          this.target.setGeometry(mp);
          cut = true;
          break;
        }
      }
      /*
      if (cut) {
        let mp = new MultiPolygon();
        for (i=0; i<polygons.length; i++) {
          mp.appendPolygon(polygons[i]);
        }
        this.target.setGeometry(mp);
      }*/
    } else if (targetGeom instanceof Polygon) {
      jstsTargetGeom = this.jstsOL3Parser.read(targetGeom);
      if (jstsHoleGeom.within(jstsTargetGeom)) {
        this.$map.addUndo(this.target, 'Update');
        targetGeom.appendLinearRing(holeGeom.getLinearRing(0));
        cut = true;
      }
    }
    if (cut) {
      targetGeom = this.target.getGeometry();
      let sqm = this.$map.calcArea(<Polygon>targetGeom);
      this.target.set('area_sqm',sqm);
      this.afterCut({
        original: original,
        modified: this.target
      });
    }
    // finally empty this.targets_ in order to continue to select and split others
    this.target = null;
  }

  afterCut(feature:ICutFeature) {
    // app may override this so that it can do setProperties()
  }

  cloneFeature(feature:Feature) : Feature {
		let f = feature.clone();
    f.setId(feature.getId());
    f['ol_uid'] = feature['ol_uid'];
		f['NATIVE_SOURCE'] = feature['NATIVE_SOURCE'];
		return f;
  };

  /**
   * override Drawer.startDraw()
   */
  startDraw(event) {
    if (!this.target) {
      this.target = this.$map.map.HighlightedFeature;
      this.$map.selectFeature(this.$map.map.HighlightedFeature);
      this['abortDrawing_']();
      return;
    }
    super.startDraw(event);
  }

  /**
   * override Drawer.endDraw()
   */
  endDraw(event) {
    this.$map.clearLayer('SelectedFeatureLayer');
    let cutter = event.feature;
    if (cutter && this.jstsOL3Parser) {
      this.startCut(cutter);
    }
    super.endDraw(event);
  }

  setMap(map:Map) {
    if (map) {
      this.$map = map['SOFTOO_MAP'];
    }
    super.setMap(map);
  }

  remove() {
    this.jstsOL3Parser = null;
    super.remove();
  }
}